import { RotateCcw, X } from "lucide-react";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Select from "react-select";
import { GetCreditNoteList, GetMasterMemberlist, GetMemberlist } from "../../Redux/Action/MasterAdminAction";
import { components } from "react-select";


const MemberListFilterSidebar = ({
  isOpen,
  onClose,
  filters,
  onFilterChange,
  optionList,
  Search,
  vfsMemberList,
  startDate,
  statusOptions,
  endDate,
  setselectpage,
  handelApplyFilter,
}) => {
  const [localFilters, setLocalFilters] = useState(filters);
  const [selectedBranches, setSelectedBranches] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [selectedStatusLabel, setSelectedStatusLabel] = useState('');
  const [branchLabel, setBranchLabel] = useState([]);

  useEffect(() => {
    setLocalFilters(filters);
    const options = optionList.filter((option) =>
      filters.corporateID.includes(option.value)
    );
    setSelectedBranches(filters.corporateID);
    setBranchLabel(options.map((option) => option.label));
    // Set status and status label
    setSelectedStatus(filters.status || "");
    if (filters.status && statusOptions) {
      const statusOption = statusOptions.find(option => option.value === filters.status);
      setSelectedStatusLabel(statusOption ? statusOption.label : "");
    } else {
      setSelectedStatusLabel("");
    }
  }, [filters]);

  const handleBranchChange = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    const labels = selectedOptions
      ? selectedOptions.map((option) => option.label)
      : [];
    setSelectedBranches(values);
    setBranchLabel(labels);
    setLocalFilters((prev) => ({
      ...prev,
      corporateID: values,
    }));
  };

  const handleSelectStatus = (selectedOptions) => {
    const values = selectedOptions?.value
    const labels = selectedOptions?.label
    setSelectedStatus(values);
    setSelectedStatusLabel(labels);
    setLocalFilters((prev) => ({
      ...prev,
      status: values,
    }));
  };

  const applyFilters = () => {
    onFilterChange(localFilters); 
    onClose();
    setselectpage(0);
    handelApplyFilter(localFilters);
  };


  const clearAllFilters = () => {
    const clearedFilters = {
      corporateID: [],
    };
    setLocalFilters(clearedFilters);
    onFilterChange(clearedFilters);
    setselectpage(0);
    handelApplyFilter(clearedFilters);
  };

  const getActiveFilterCount = () => {
    return (
      localFilters.corporateID.length + (localFilters.status ? 1 : 0)
    );
  };
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? "#fff100" : "#ececec",
      boxShadow: "none",
      "&:hover": { borderColor: "#ececec" },
    }),
    placeholder: (base) => ({
      ...base,
      color: "#262626",
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "2px 8px",
      minHeight: "38px", // instead of fixed height
      height: "auto", // allow it to expand
      flexWrap: "wrap", // let multiple values wrap
      overflow: "visible", // show all selected
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      color: "#262626",
      height: "38px",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: "transparent",
      color: "black",
      display: "flex",
      alignItems: "center",
      "&:hover": {
        backgroundColor: "#f8f8f8",
      },
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0,
    }),
  };
  const CheckboxOption = (props) => {
    return (
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null} // prevent default behavior
          className="mr-2"
        />
        <label>{props.label}</label>
      </components.Option>
    );
  };
  return (
    <>
      <div
        className={`fixed right-0 top-0 h-full w-[500px] bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out ${
          isOpen ? "translate-x-0" : "translate-x-full"
        } flex flex-col`}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-2 border-b border-gray-200 bg-[#FCDD00]">
          <div className="flex items-center">
            <h2 className="my-[7px] text-xl font-semibold text-gray-900">Filters</h2>
          </div>
          <button
            onClick={onClose}
            className="p-2 transition-colors duration-200 rounded-full hover:bg-white hover:bg-opacity-50"
          >
            <X className="w-5 h-5 text-gray-600" />
          </button>
        </div>

        {/* Filter Content */}
        <div className="flex-1 p-6 space-y-6 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 hover:scrollbar-thumb-gray-400">
          {/* branch filter */}
          <div className="space-y-3">
            <label className="block text-sm font-medium text-gray-700">
              Branch
            </label>
            <Select
              isMulti
              options={optionList}
              value={optionList.filter((option) =>
                selectedBranches.includes(option.value)
              )}
              onChange={handleBranchChange}
              placeholder="Select Branch"
              styles={customStyles}
              classNamePrefix="react-select"
              isSearchable={true}
              closeMenuOnSelect={false}
              isClearable={false}
              hideSelectedOptions={false}
              components={{
                Option: CheckboxOption,
                IndicatorSeparator: () => null,
              }}
            />
          </div>
          {/* Status Refund */}
          <div className="space-y-3">
            <label className="block text-sm font-medium text-gray-700">
              Status
            </label>
            <Select
              options={statusOptions}
              placeholder="Select status"
              value={selectedStatus ? statusOptions?.find(option => option.value === selectedStatus) : null}
              onChange={handleSelectStatus}
              isSearchable={false}
              closeMenuOnSelect={true}
              isMulti={false}
              isClearable={false}
              styles={customStyles}
              components={{ IndicatorSeparator: () => null }}
            />
          </div>
          {/* Selected Filters Summary */}
          {getActiveFilterCount() > 0 && (
            <div className="space-y-3 p-4 bg-[#fff7bbc9] rounded-lg border border-[#FCDD00]">
              <h3 className="text-sm font-semibold text-black">
                Selected Filters:
              </h3>
              <div className="space-y-2">
                {localFilters.corporateID.length > 0 && (
                  <div>
                    <span className="text-xs font-semibold text-black">
                      Branch:{" "}
                    </span>
                    <span className="text-xs text-black">
                      {branchLabel.map((branch) => branch).join(", ")}
                    </span>
                  </div>
                )}
                {localFilters.status && (
                  <div>
                    <span className="text-xs font-semibold text-black">
                      Status:{" "}
                    </span>
                    <span className="text-xs text-black">
                      {selectedStatusLabel || selectedStatus}
                    </span>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Footer Actions */}
        <div className="flex flex-row gap-3 p-6 border-t border-gray-200 bg-gray-50">
          <button
            onClick={applyFilters}
            className="w-full bg-[#FCDD00] text-black py-3 px-4 rounded-lg hover:bg-[#FCDD00] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-200 font-medium"
          >
            Apply Filters
          </button>

          {(getActiveFilterCount() > 0) && (
            <button
              onClick={clearAllFilters}
              className="flex items-center justify-center w-full px-4 py-3 font-medium text-gray-700 transition-colors duration-200 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
            >
              <RotateCcw className="w-4 h-4 mr-2" />
              Clear All Filters
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default MemberListFilterSidebar;
